import Blazy from "blazy";
import Gallery from "./gallery";

const common = {
  lastScroll: $(window).scrollTop(),
  init: function () {
    common.waitForWebfonts(["Avenir"], function () {
      $("body").addClass("loaded");
    });
    common.lazyload();
    common.events();
    common.scroll.init();

    if ($(".gallery").length) {
      Gallery.init();
    }
  },

  lazyload: function () {
    window.bLazy = new Blazy();
  },

  events: function () {
    var windowScrollTop = $(window).scrollTop();
    // toggle main navigation mobile
    $(".js-toggle-mobile-menu").click(function (e) {
      e.preventDefault();
      if (!$(".header").hasClass("header--mobile-open"))
        windowScrollTop = $(window).scrollTop();
      $(".header").toggleClass("header--mobile-open");
      $("html").toggleClass("no-scroll");
      $("html, body").scrollTop(windowScrollTop);
    });

    // Submenu functionality
    $(".menu-item-has-children.active").addClass("dropped");
    $(".menu-item-has-children").on("click", function (event) {
      // console.log($(event.target));
      if ($(window).width() < 993) {
        $(".sub-menu", this).slideToggle(300);
        $(this).toggleClass("dropped");
      }
    });

    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    setInterval(common.scroll2, 100);

    // Prod categories toggle
    $(".toggle-cats").on("click", function () {
      $(".leftmenu").toggleClass("open");
    });
    $(document).keyup(function (e) {
      if (e.keyCode === 27) {
        $(".leftmenu").removeClass("open");
      }
    });
  },

  scroll: {
    sticky: false,
    topbar: false,
    last: 0,

    init: function () {
      common.scroll.do();
      $(window).scroll(function () {
        common.scroll.do();
      });
    },

    do: function () {
      var st = $(window).scrollTop();

      if (st > 40 && !common.scroll.sticky) {
        common.scroll.sticky = true;
        $(".header").addClass("header--scrolled");
      } else if (st < 40 && common.scroll.sticky) {
        common.scroll.sticky = false;
        $(".header").removeClass("header--scrolled");
      }

      common.scroll.last = st;
    },
  },

  scroll2: function (e) {
    if (!$(".no-scroll").length) {
      $(".header").toggleClass("scrolled", $(window).scrollTop() > 32);
      common.lastScroll = $(window).scrollTop();
    }
    common.checkVisibleElements();
  },

  checkVisibleElements: function (elements) {
    var windowScrolled = $(window).scrollTop() + $(window).height();
    var index = 0;
    var prevOffset = 0;
    /* Animate scale */
    $(".animate:not(.animate--visible, .animate--waiting)").each(function (
      i,
      element
    ) {
      var currentOffset = $(element).offset().top;
      if (prevOffset != currentOffset) {
        prevOffset = currentOffset;
        index = 0;
      }
      if (currentOffset < windowScrolled || $(element).hasClass("offer")) {
        setTimeout(function () {
          $(element)
            .addClass("animate--visible")
            .removeClass("animate--waiting");
        }, index * 50);
        $(element).addClass("animate--waiting");
        index++;
      }
    });
    /* Animate slide */
    $(".animate-slide:not(.animate--visible, .animate--waiting)").each(
      function (i, element) {
        var currentOffset = $(element).offset().top;
        if (prevOffset != currentOffset) {
          prevOffset = currentOffset;
          index = 0;
        }
        if (
          currentOffset + 150 < windowScrolled ||
          $(element).hasClass("offer")
        ) {
          setTimeout(function () {
            $(element)
              .addClass("animate-slide--visible")
              .removeClass("animate-slide--waiting");
          }, index * 50);
          $(element).addClass("animate--waiting");
          index++;
        }
      }
    );
  },

  waitForWebfonts: function (fonts, callback) {
    var loadedFonts = 0;
    for (var i = 0, l = fonts.length; i < l; ++i) {
      (function (font) {
        var node = document.createElement("span");
        // Characters that vary significantly among different fonts
        node.innerHTML = "giItT1WQy@!-/#";
        // Visible - so we can measure it - but not on the screen
        node.style.position = "absolute";
        node.style.left = "-10000px";
        node.style.top = "-10000px";
        // Large font size makes even subtle changes obvious
        node.style.fontSize = "300px";
        // Reset any font properties
        node.style.fontFamily = "sans-serif";
        node.style.fontVariant = "normal";
        node.style.fontStyle = "normal";
        node.style.fontWeight = "normal";
        node.style.letterSpacing = "0";
        document.body.appendChild(node);

        // Remember width with no applied web font
        var width = node.offsetWidth;

        node.style.fontFamily = font;

        var interval;
        function checkFont() {
          // Compare current width with original width
          if (node && node.offsetWidth != width) {
            ++loadedFonts;
            node.parentNode.removeChild(node);
            node = null;
          }

          // If all fonts have been loaded
          if (loadedFonts >= fonts.length) {
            if (interval) {
              clearInterval(interval);
            }
            if (loadedFonts == fonts.length) {
              callback();
              return true;
            }
          }
        }

        if (!checkFont()) {
          interval = setInterval(checkFont, 50);
        }
      })(fonts[i]);
    }
  },
};

export default common;
